<template>
    <div class="form_flex_wrap">
        <div class="form_flex_title">
            <span class="title">{{ $t('work_schedule.popup_operation_settings.title_staff_management') }}</span>    
        </div>
        <div class="form_flex_cont" v-if="!departments.length">
            <div class="no_cont">{{ $t('work_schedule.popup_operation_settings.label_no_department') }}</div>
        </div>
        <EmployeesControlPanelWithDepartmentTabs v-if="!!departments.length" :departments="departments" />
    </div>
</template>

<script>
import EmployeesControlPanelWithDepartmentTabs from './EmployeesControlPanelWithDepartmentTabs.vue'

export default {
    components: {
        EmployeesControlPanelWithDepartmentTabs
    },
    props: {
        departments: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<style lang="scss" scoped></style>
